module.exports = {
      id: "ic-100-index-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#ic-100-index-usage",
      toString: function () {
        return this.url;
      }
    }